exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2bfUPI2jPM0b8zbt-FHbLO{margin:20px 0px 20px 0px}\n", ""]);

// Exports
exports.locals = {
	"horizontalOpts": "_2bfUPI2jPM0b8zbt-FHbLO"
};